<template>
    <div class="page-content">

        <div id="soundlist" class="section grow bg-svg-messagebottle">
            <div class="overlay opacity-50"></div>
            <div class="container h-100">
                <div class="d-flex h-100 text-center align-items-center">
                    <div class="w-100 color-white">
                        <h1 class="title color-white mb-5">List of sleep sounds on Fire TV.</h1>
                        <p class="lead mb-5">These ambient sounds are available in the Sleep Jar app for Fire TV!</p>
                        <div class="row text-center mb-5">
                            <div class="col-md-6 mb-5 ml-auto mr-auto">
                                <a :href="$root.app_link.firetv" target="_blank" class="btn btn-lg btn-light"><i class="fas mr-2 fa-tv"></i>Install Sleep Jar for Fire TV</a>
                            </div>
                        </div>

                        <div class="col-sm-12 ml-auto mr-auto mb-10">
                            <div class="row">
                                <media-item v-for="(item, itemKey, index) in filteredMedia.SOUND"
                                    v-bind:emitConfig="emit_config"
                                    v-bind:item="item"
                                    v-bind:key="itemKey"
                                    v-bind:index="index"
                                    v-bind:itemKey="itemKey"
                                    v-bind:showDetailLink="true"
                                    v-bind:platform="'firetv'"
                                    ref="previews"
                                />
                            </div>
                        </div>

                        <p class="lead mb-5">Turn your Fire TV into a white noise machine for better sleep, relaxation, and focus!</p>
                        <div class="row text-center mb-5">
                            <div class="col-md-6 ml-auto mr-auto">
                                <a :href="$root.app_link.firetv" target="_blank" class="btn btn-lg btn-light"><i class="fas mr-2 fa-tv"></i>Get Sleep Jar for Fire TV</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import { EventBus } from '../../event-bus.js';
export default {
    data () {
        return {
            "media": require('../../assets/media.js'),
            "emit_config": {
                "pool": "sounds",
                "emitter": "sounds-stop"
            }
        };
    },
    name: 'sounds',
    metaInfo: {
        title: 'Fire TV',
        meta: [
            {
                'name': 'description',
                'property': 'og:description',
                'content': 'The full list of sleep sounds on Fire TV, available in Sleep Jar!'
            }
        ]
    },
    methods: {
        filteredMediaRoughCount (type = "SOUND") {
            return this.filteredMediaCount(type) - this.filteredMediaCount(type)%10;
        },
        filteredMediaCount (type = "SOUND") {
            var keys = Object.keys(this.filteredMedia[type]);
            return keys.length;
        },
    },
    computed: {
        "filteredMedia": function(){
            let media = {
                "SOUND": {},
                "STORY": {},
                "MEDITATION": {},
                "JOURNEY": {}
            };
            Object.entries(this.media).forEach(function([key, item], index){
                media[item.type][key] = item;
            });
            return media;
        },
    },
    components: {
    },
    mounted(){
        EventBus.$on(this.emit_config.emitter, function(index){
            this.$refs.previews[index].stopAudio();
        }.bind(this));
    }
}
</script>
